import { api } from './baseApi';
export var restNetworkApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            // 🔹 Получить все сети
            getAllNetworks: builder.query({
                query: function () {
                    return ({
                        url: '/restNetwork',
                        method: 'GET',
                    });
                },
                providesTags: ['RestNetwork'],
                keepUnusedDataFor: 0,
            }),
            // 🔹 Получить одну сеть по ID
            getNetworkById: builder.query({
                query: function (id) {
                    return ({
                        url: "/restNetwork/".concat(id),
                        method: 'GET',
                    });
                },
                providesTags: function (result, error, id) { return [{ type: 'RestNetwork', id: id }]; },
            }),
            // 🔹 Создать сеть
            createNetwork: builder.mutation({
                query: function (body) {
                    return ({
                        url: '/restNetwork',
                        method: 'POST',
                        body: body,
                    });
                },
                invalidatesTags: ['RestNetwork'],
            }),
            // 🔹 Удалить сеть
            deleteNetwork: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/restNetwork/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['RestNetwork'],
            }),
            updateNetwork: builder.mutation({
                query: function (_a) {
                    var id = _a.id, body = _a.body;
                    return ({
                        url: "/restNetwork/".concat(id),
                        method: 'PATCH',
                        body: body,
                    });
                },
                invalidatesTags: function (result, error, _a) {
                    var id = _a.id;
                    return ['RestNetwork', { type: 'RestNetwork', id: id }];
                },
            }),
            uploadNetworkPhoto: builder.mutation({
                query: function (_a) {
                    var id = _a.id, file = _a.file;
                    var body = new FormData();
                    body.append('file', file);
                    return {
                        url: "/restNetwork/".concat(id, "/photo"),
                        method: 'POST',
                        body: body,
                    };
                },
                invalidatesTags: function (result, error, _a) {
                    var id = _a.id;
                    return ['RestNetwork', { type: 'RestNetwork', id: id }];
                },
            }),
            getNetworkRestaurants: builder.query({
                query: function (_a) {
                    var id = _a.id, cityId = _a.cityId;
                    return ({
                        url: cityId != null
                            ? "/restNetwork/".concat(id, "/restaurants?cityId=").concat(cityId)
                            : "/restNetwork/".concat(id, "/restaurants"),
                        method: 'GET',
                    });
                },
                providesTags: function (result, error, _a) {
                    var id = _a.id;
                    return [{ type: 'RestNetwork', id: id }];
                },
            }),
            getNetworkMonthlyPayments: builder.query({
                query: function (_a) {
                    var id = _a.id, year = _a.year, month = _a.month;
                    return ({
                        url: "/restNetwork/".concat(id, "/payments/monthly?year=").concat(year, "&month=").concat(month),
                        method: "GET",
                    });
                },
                providesTags: ['RestNetwork'],
            }),
            getAllNetworksMonthlyPayments: builder.query({
                query: function (_a) {
                    var year = _a.year, month = _a.month;
                    return ({
                        url: "/restNetwork/all/payments/monthly?year=".concat(year, "&month=").concat(month),
                        method: "GET",
                    });
                },
                providesTags: ['RestNetwork'],
            }),
            getCityMonthlyPayments: builder.query({
                query: function (_a) {
                    var cityId = _a.cityId, year = _a.year, month = _a.month;
                    return ({
                        url: "/restNetwork/city/".concat(cityId, "/payments/monthly?year=").concat(year, "&month=").concat(month),
                        method: "GET",
                    });
                },
                providesTags: ['RestNetwork'],
            }),
        });
    },
});
export var useGetAllNetworksQuery = restNetworkApi.useGetAllNetworksQuery, useGetNetworkByIdQuery = restNetworkApi.useGetNetworkByIdQuery, useCreateNetworkMutation = restNetworkApi.useCreateNetworkMutation, useDeleteNetworkMutation = restNetworkApi.useDeleteNetworkMutation, useUpdateNetworkMutation = restNetworkApi.useUpdateNetworkMutation, useUploadNetworkPhotoMutation = restNetworkApi.useUploadNetworkPhotoMutation, useGetNetworkRestaurantsQuery = restNetworkApi.useGetNetworkRestaurantsQuery, useGetNetworkMonthlyPaymentsQuery = restNetworkApi.useGetNetworkMonthlyPaymentsQuery, useGetAllNetworksMonthlyPaymentsQuery = restNetworkApi.useGetAllNetworksMonthlyPaymentsQuery, useGetCityMonthlyPaymentsQuery = restNetworkApi.useGetCityMonthlyPaymentsQuery;
